// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// services
import { ObjectUtil, QuickOrderService } from "@/services";

// components
import { stringHelper } from "@/components/mixins/stringHelper";
import { default as PartListing } from "../PartListing.vue";

// types
import { IGridListRowItem } from "@/components/Elements/PartsListGrid/PartsListGrid";
import { IQuickOrdersContext } from "../../QuickOrders.types";

export default Vue.extend({
  name: "AddToCartDialog",
  components: {
    PartListing,
  },
  mixins: [stringHelper],
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
    items: {
      type: Array,
      default: () => [] as IGridListRowItem[],
    },
    isPartList: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    removeSelectedItemsFromQuickOrder: true
  }),

  computed: {
    ...mapGetters(["getContentItem"]),
  },

  methods: {
    async addSelectedItemsToCart(goToCart: boolean, event: PointerEvent) {
      const context = this.context as IQuickOrdersContext;
      const items = this.items as IGridListRowItem[];
      
      event.target.disabled = true;

      try {
        this.$emit("on-parts-adding");

        const rq = {
          accountId: context.accountId,
          userId: context.user.UserId,
          sourceListId: Number(context.partListId),
          sourceItemIds: items.filter((x) => x.Selected).map((x) => x.Id),
          removeImportedItemsFromSource: this.isPartList ? false : this.removeSelectedItemsFromQuickOrder,
        };

        const result = await QuickOrderService.addToCart(rq);

        this.$emit("on-parts-added", result);

        if (goToCart) {
          this.$router.push({ name: "ShoppingCart" });
        } else {
          this.$emit("reload-quick-order");
        }
      } finally {
        this.$store.dispatch("LOAD_CART_SUMMARY", {
          accountId: context.accountId,
          userId: context.user.UserId,
        });
        event.target.disabled = false;
      }
    },

    cancel() {
      this.$emit("on-cancel");
    },
  },
});
